// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"c3a2fa26","513":"5424a76b","703":"411d119d","787":"20fbedb4"}[chunkId] + ".chunk.js";
};